import BaseStorageProvider from "./BaseStorageProvider";
import isEmpty from "lodash/isEmpty";
import ApiGetter from "shared/models/ApiGetter";

class TableApiStorageProvider extends BaseStorageProvider {
    constructor(endpoint) {
        super();
        this.endpoint = endpoint || "";
    }

    get(dispatcher, callback) {
        if (isEmpty(this.endpoint)) {
            super.get(dispatcher, callback);
            return;
        }

        let apiGetter = new ApiGetter(dispatcher, { disableLoadSpinner: true });
        apiGetter.fetchSearchResults(
            this.endpoint,
            callback,
            () => {
                dispatcher.emit("SHOW_FLASH_MESSAGE", {
                    message: "Oops! We couldn't load that data.",
                    className: "warning"
                });
            }
        );
    }
}

export default TableApiStorageProvider;
